"use strict";

class Dan_RangeInput {
	/** @var {HTMLElement} */
	#$group;

	/** @var {HTMLInputElement} */
	#$input;

	/** @var {HTMLOutputElement|null} */
	#$output;


	constructor($group) {
		this.#$group = $group;
	}

	initialize() {
		this.#$input  = this.#$group.querySelector("input[type='range']");
		this.#$output = this.#$group.querySelector("output");

		this.#$group.classList.add("-initialized");

		if (this.#$output) {
			this.#$input.addEventListener("input", this.refreshOutput.bind(this));
			this.refreshOutput();
		}
	}

	refreshOutput() {
		// Format output.
		const format              = this.#$output.getAttribute("data-format");
		this.#$output.textContent = (format)
			? format.replaceAll("{{value}}", this.#$input.value)
			: this.#$input.value;

		// Set output position.
		const inputMin       = parseFloat(this.#$input.min);
		const inputMax       = parseFloat(this.#$input.max);
		const inputRange     = (inputMax - inputMin);
		const absoluteValue  = (this.#$input.value - inputMin);
		const percentage     = (100 / inputRange * absoluteValue);

		const outputOffsetPx = (this.#$output.offsetWidth / 2);
		const thumbOffsetRem = (((50 - percentage) * 2 / 100) * 0.625);

		this.#$output.style.left = `calc(${percentage}% + ${thumbOffsetRem}rem - ${outputOffsetPx}px)`;
	}
}